import { mapState } from "vuex";

import {
  getRoleConfig,
  canUserAddEvents,
  canViewDashboard,
  canViewCompletedOrders,
  canViewAlbumViewsTable,
  getSummarySalesPermissions
} from "@/config/userRoleConfig";

export default {
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      citiesList: (state) => state.global.citiesList,
      countriesList: (state) => state.global.countriesList,
    }),
    userRole() {
      return this.user?.role;
    },
    roleConfig() {
      return getRoleConfig(this.userRole) || {};
    },
    roleFields() {
      return this.roleConfig.fields || {};
    },
    canViewDashboard() {
      return canViewDashboard(this.userRole);
    },
    canViewCompletedOrders() {
      return canViewCompletedOrders(this.userRole);
    },
    canViewAlbumViewsTable() {
      return canViewAlbumViewsTable(this.userRole);
    },
    canAddEvent() {
      return canUserAddEvents(this.userRole);
    },
    hasDashboardAccess() {
      return this.roleConfig.dashboardAccess.enabled;
    },
    shouldShowUnverifiedTab() {
      return this.roleConfig.showUnverifiedTab;
    },
    cities() {
      return this.citiesList;
    },
    countries() {
      return this.countriesList;
    },
    getSummarySalesPermissions() {
      return getSummarySalesPermissions(this.userRole);
    },
    canEditEventSponsorImage() {
      return this.roleConfig.canEditEventSponsorImage;
    }
  },
  methods: {
    isFieldEnabled(fieldKey) {
      return !!this.roleFields[fieldKey];
    },
    canEditEvent(event) {
      if (!event && this.canAddEvent) {
        return true
      }

      return (
        this.canAddEvent &&
        this.user && 
        this.user.id === event.postAuthor && 
        (event.eventType === 'nonstandard' || event.eventType === 'private')
      );
    },
    goToDashboard(eventId) {
      this.$router.push(`/my-events/${eventId}`);
    },
    getCityLabel(cityId) {
      if (!cityId || !this.cities || this.cities.length === 0) {
        return null;
      }
      const city = this.cities.find(c => c.id === cityId);
      return city ? city.label : null;
    },
    getCountryLabel(countryId) {
      if (!countryId || !this.countries || this.countries.length === 0) {
        return null;
      }
      const country = this.countries.find(c => c.id === countryId);
      return country ? country.label : null;
    },
  }
};